<template>
    <TransitionRoot
        as="template"
        :show="isOpen"
    >
        <Dialog
            as="div"
            class="relative z-[60]"
            @close="handleClose"
        >
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 overflow-y-auto z-[60]">
                <div class="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enter-to="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 sm:scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <DialogPanel
                            class="relative bg-white dark:bg-neutral-600 rounded-lg text-left  shadow-xl transform transition-all sm:my-8 sm:w-full"
                            :class="maxW"
                        >
                            <div class="bg-white dark:bg-neutral-800 px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                                <div class="sm:flex sm:items-start">
                                    <div class="mt-1 text-center sm:mt-0  sm:text-left w-full space-y-4">
                                        <DialogTitle
                                            as="h3"
                                            class="text-xl leading-6 font-medium text-gray-900 dark:text-neutral-300 "
                                        >
                                            {{ title }}
                                            <span
                                                class="absolute top-6 right-6 cursor-pointer dark:hover:text-neutral-400"
                                                @click="handleClose"
                                            > X </span>
                                        </DialogTitle>
                                        <slot name="content" />
                                    </div>
                                </div>
                            </div>
                            <div class="bg-gray-50 dark:bg-neutral-800 px-4 py-6 sm:px-6 sm:flex sm:flex-row-reverse">
                                <slot name="footer" />
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
    import { ref, defineProps, defineEmits, watch } from 'vue'
    import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'
    
    const emit = defineEmits(['applyFilter','close'])
    const props = defineProps({
        loading: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '',
        },
        open:{
            type: Boolean,
            default: false,
        },
        maxw: {
            type: String,
            default: 'lg',
        },
    })
    
    const maxWidth = {
        lg: 'sm:max-w-lg',
        xl: 'sm:max-w-xl ',
        xl2: 'sm:max-w-2xl ',
        xl3: 'sm:max-w-3xl ',
        xl4: 'sm:max-w-4xl ',
        xl5: 'sm:max-w-5xl ',
        xl6: 'sm:max-w-6xl ',
        xl7: 'sm:max-w-7xl ',
    }
    const isOpen = ref(props.open)
    const maxW = ref(maxWidth[props.maxw])

    function handleClose() {
        emit('close', false )
    }
    watch(() => props.open, (value) => {
        isOpen.value = value
    } )
</script>